import Api from "../apiService";

class messagesApi {
  index(companyId, conversationId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/conversations/${conversationId}/messages`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, conversationId, messageId) {
    return Api.getRequest(
      `companies/${companyId}/conversations/${conversationId}/messages/${messageId}`,
      {},
      Api.authHeaders()
    );
  }

  sendMessage(companyId, conversationId, message) {
    return Api.postRequest(
      `companies/${companyId}/conversations/${conversationId}/messages`,
      message,
      Api.authHeaders()
    );
  }

  retry(companyId, conversationId, messageId) {
    return Api.postRequest(
      `companies/${companyId}/conversations/${conversationId}/messages/${messageId}/retry`,
      {},
      Api.authHeaders()
    );
  }
}

export default new messagesApi();
